export const EMPTY_RATE = { current: 0, dec_aop: 0, dec_fcst: 0, issues: [] };
export const UNAVAILABLE_RATE = { current: null, dec_aop: null, dec_fcst: null, issues: ['Run-rate calculation unavailable for this scope.'] };
// Sums whichever rows have a value for each figure instead of blanking the
// whole total the moment one row is null — mirrors aggregate_rates() in the
// backend's run_rates.py. `excluded[key]` reports how many of the summed
// rows had no value for that key, so a partial total is never presented as
// if it were complete.
export function sumRunRates(rows) {
    const total = rows.length;
    const excluded = {};
    const sums = Object.fromEntries(['current', 'dec_aop', 'dec_fcst'].map(key => {
        const values = rows.map(r => r?.[key]).filter(v => v != null);
        if (values.length < total) excluded[key] = total - values.length;
        return [key, values.length ? values.reduce((sum, v) => sum + v, 0) : null];
    }));
    return { ...sums, excluded, total_records: total };
}
export function runRateSplit(summary, department, source = [], yearMode = 'current') {
    const yearModes = Array.isArray(yearMode) ? yearMode : (yearMode ? [yearMode] : []);
    const modes = yearModes.length ? yearModes : ['current'];
    // Run Rate is an annualized CURRENT-year concept with no prior-year
    // equivalent — selecting Current (alone or together with Prior) shows
    // the normal split; selecting only Prior shows unavailable, same as the
    // old single-select 'prior' behavior.
    if (!summary || !modes.includes('current')) return { hc: UNAVAILABLE_RATE, nonhc: UNAVAILABLE_RATE, commission: UNAVAILABLE_RATE };
    const hcIncluded = !source.length || source.includes('hc');
    const nonhcIncluded = !source.length || source.includes('nonhc');
    const commissionIncluded = !source.length || source.includes('commission');
    const departments = Array.isArray(department) ? department : (department ? [department] : []);
    const get = section => {
        if (!departments.length) return section?.total?.run_rate || EMPTY_RATE;
        return sumRunRates(departments.map(d => section?.by_category?.[d]?.run_rate || EMPTY_RATE));
    };
    return {
        hc: hcIncluded ? get(summary.headcount_costs) : EMPTY_RATE,
        nonhc: nonhcIncluded ? get(summary.non_headcount_costs) : EMPTY_RATE,
        // Commission only exists for the Sales APAC/NAM/Solution dashboards
        // (summary.commission_costs is absent everywhere else) — EMPTY_RATE
        // either way once Commission is excluded from the selection, same
        // convention as the hc/nonhc branches above.
        commission: (commissionIncluded && summary.commission_costs) ? get(summary.commission_costs) : EMPTY_RATE,
    };
}
